module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAB1JREFUGBljZPjv85+BCMBEhBqwklGFeEOK6OABALVxAl7H/c2oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/carbs.png
// module id = 143
// module chunks = 7